import React from 'react';
import block from 'bem-cn';
import { Link } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';

import SVG from 'components/SVG';

import walletSVG from './img/wallet.svg';
import arrowSVG from './img/arrow.svg';
import './HeaderBanner.scss';

const b = block('header-banner-mobile');

const HeaderBanner = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const role = useSelector(state => state.auth.role, shallowEqual);

  if (role !== 1) return null;

  return (
    <div className={b()}>
      <Link className={b('link')} to="/active-requests">
        <SVG className={b('icon')} svgProps={{ svg: walletSVG }} />
        {locale.withdrawalMoney}
        <SVG className={b('arrow')} svgProps={{ svg: arrowSVG }} />
      </Link>
    </div>
  );
};

export default HeaderBanner;
